import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';

@Component({
  selector: 'option-itinerary',
  templateUrl: './option-itinerary.component.html',
  styleUrls: ['./option-itinerary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionItineraryComponent {
  @Input() itinerary: PortalFlightItineraryGroupNode;
}
